import { render, staticRenderFns } from "./UserLicensesManager.vue?vue&type=template&id=50f7c0d5&scoped=true&"
import script from "./UserLicensesManager.vue?vue&type=script&lang=js&"
export * from "./UserLicensesManager.vue?vue&type=script&lang=js&"
import style0 from "./UserLicensesManager.vue?vue&type=style&index=0&id=50f7c0d5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f7c0d5",
  null
  
)

export default component.exports